export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_PDS_AGENCY_BM-79471486e98ae829a12f1d06247930e6.pdf";